export const orderStatus = {
    wait_confirm: { icon: 'icon-fl-sort-filled', name: 'Đợi xác nhận' },
    confirming: { icon: 'icon-fl-sort-filled', name: 'Đang xác nhận' },
    wait_payment: { icon: 'icon-fl-sort-filled', name: 'Đợi thanh toán' },
    paid: { icon: 'icon-fl-sort-filled', name: 'Đã thanh toán' },
    delivered: { icon: 'icon-fl-sort-filled', name: 'Đã chuyển đồ' },
    canceled: { icon: 'icon-fl-sort-filled', name: 'Huỷ bỏ' },
}
